export const MIN_REQUIRED_PLAYER_COUNT = 3;
export const ORIGINAL_DEALER_INDEX = 0;
